import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { pipelineRunsApi } from '@/lib/api/pipeline-runs.api';

import type { ImprovementSettings } from '@/lib/api/pipeline-runs.api';

const QK = ['improvement-settings'];

export const useImprovementSettings = (configId: string) =>
  useQuery({
    queryKey: [...QK, configId],
    queryFn: () => pipelineRunsApi.getSettings(configId),
    enabled: !!configId,
  });

export const useUpdateImprovementSettings = (configId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<ImprovementSettings>) =>
      pipelineRunsApi.updateSettings(configId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...QK, configId] }),
  });
};
